// Cache key of one compared scan pair; shared by the store and the rank section
export const rankCompareKey = (arg: {
  params: { heatmapId: string; scanA: string; scanB: string };
}): string => `${arg.params.heatmapId}:${arg.params.scanA}:${arg.params.scanB}`;
